import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AfroTechConnectBannerService {

    private API_URL= environment.API_URL;

    constructor(
        private http : HttpClient
    ) {}

    getData(){
        let url = `${this.API_URL}/speakers?populate=*&sort=updatedAt:DESC`;
        return this.http.get(url, { headers: {'Authorization': `Bearer ${environment.API_TOKEN}`}});
    }

}